import React, { useState } from "react";
import "../Styles/ContactForm.css";
import { FaEnvelope, FaMapMarkerAlt, FaPhone } from "react-icons/fa";
import { useTranslation } from "react-i18next"; // Import useTranslation hook

const ContactForm = () => {
    const { t } = useTranslation(); // Initialize translation function
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    subject: "",
    message: "",
  });

  const [errorMsg, setErrorMsg] = useState(""); // 🔴 Error Message State

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });

    // ✅ Live Phone Validation
    if (e.target.name === "phone") {
      const phonePattern = /^\d{10}$/;
      if (!phonePattern.test(e.target.value)) {
        setErrorMsg("Please enter a valid 10-digit phone number!");
      } else {
        setErrorMsg(""); // ✅ Valid phone number -> Error message remove
      }
    }
  };

  const sendMessage = () => {
    const { name, phone, email, subject, message } = formData;
  
    const phonePattern = /^\d{10}$/;
    if (!phonePattern.test(phone)) {
      setErrorMsg("Please enter a valid 10-digit phone number!");
      return;
    }
  
    // Format message for WhatsApp with proper encoding
    const formattedMessage = encodeURIComponent(
      `Hello, I am ${name}.\n
      📞 Phone: ${phone}\n
      📧 Email: ${email}\n
      📌 Subject: ${subject}\n
      ✍️ Message: ${message}`
    );
  
    const salesManagerNumber = "919826273330";
    const whatsappUrl = `https://api.whatsapp.com/send?phone=${salesManagerNumber}&text=${formattedMessage}`;
  
    window.open(whatsappUrl, "_blank");
  
    // ✅ Reset form fields after sending message
    setFormData({
      name: "",
      phone: "",
      email: "",
      subject: "",
      message: "",
    });
  };
  

  return (
    <div className="contact-container">
      <div className="contact-form">
        <h2>{t("contactForm.title")}</h2>
        <p>{t("contactForm.topHeading")}</p>
        <div className="form-group">
          <input
            type="text"
            name="name"
            placeholder={t("contactForm.namePH")}
            value={formData.name}
            onChange={handleChange}
            required
          />
          <input
            type="tel"
            name="phone"
            placeholder={t("contactForm.phonePH")}
            value={formData.phone}
            onChange={handleChange}
            required
          />
        </div>
        {/* 🔴 Show Error Message if Phone is Invalid */}
        {errorMsg && <p style={{ color: "red", fontSize: "14px" }}>{errorMsg}</p>}

        <div className="form-group">
          <input
            type="email"
            name="email"
            placeholder={t("contactForm.emailPH")}
            value={formData.email}
            onChange={handleChange}
            required
          />
          <input
            type="text"
            name="subject"
            placeholder={t("contactForm.subjectPH")}
            value={formData.subject}
            onChange={handleChange}
          />
        </div>
        <textarea
          name="message"
          placeholder={t("contactForm.textPH")}
          value={formData.message}
          onChange={handleChange}
          required
        ></textarea>

        {/* 🔴 Disable Button If Phone Number is Invalid */}
        <button className="sendBtn" onClick={sendMessage} disabled={errorMsg !== ""}>
        {t("contactForm.sendButton")}
        </button>
      </div>

      <div className="contact-info">
        <h3>{t("contactForm.cName")}</h3>
        <p>{t("contactForm.ISO")}</p>
        <div className="contact-item" style={{ display: "flex", alignItems: "flex-start" }}>
          <FaMapMarkerAlt className="icon location" style={{ marginTop: "5px", flexShrink: 0 }} />
          <span>{t("contactForm.address")}</span>
        </div>
        <div className="contact-item">
          <FaEnvelope className="icon email" />
          <span>globecrop@gmail.com</span>
        </div>
        <div className="contact-item">
          <FaPhone className="icon phone" />
          <span>9826121210</span>
        </div>
        <div className="contact-item">
          <FaPhone className="icon phone" />
          <span>9826273330</span>
        </div>
        <div className="contact-item">
          <FaPhone className="icon phone" />
          <span>0731-4063751</span>
        </div>
        <div className="contact-item">
          <FaPhone className="icon phone" />
          <span>1800-121-2016 (TOLL FREE)</span>
        </div>
      </div>

    </div>
  );
};

export default ContactForm;
